import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    position: "relative",
    width: "100%",
  },
  container: {
    height: "calc(100vh - 450px)",
  },
  button: {
    marginBottom: "16px",
  },
  rowHeader: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap"
  },
  colTitle: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    width: '50%',
    paddingLeft: 5,
    paddingTop: 15,
    paddingBottom: 15
  },
  colButton: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: 'flex-end',
    width: '50%',
    paddingRight: 8,
    paddingTop: 25,
    paddingBottom: 15
  },
  headerTitle: {    
    fontSize: 16,    
    fontWeight: 700
  },
  subheader: {    
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.7)",
  },
  titleObs: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    fontSize: 14,
    padding: "15px 0",
    fontStyle: "italic",
    fontWeight: "bold",
  },
  atencao: {
    display: "flex",
    flexDirection: "row",
    fontSize: 14,
    padding: "15px 0",
    fontStyle: "italic",
  },
});
